import React from "react";
import PropTypes from "prop-types";
import CheckIcon from "@mui/icons-material/Check";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { Typography } from "@mui/material";

import Card from "../../../../../../../components/Card";

const ReviewChangesSummary = ({ changeCount, cl }) => (
  <Card
    title={cl.changesSummary}
    classNames={{
      root: "review-changes-summary-card",
      body: "review-changes-summary-card__body",
    }}
  >
      <div className="d-flex gap-2 mb-3 review-changes-summary-card__legend-row">
        <CheckIcon
          sx={{
            color: "var(--color-success-hover, #166534)",
            fontSize: 14,
            backgroundColor: "var(--color-success-subtle, #F0FDF4)",
            borderRadius: "50%",
          }}
        />
        <div>
          <Typography variant="subtitle2" className="fweight-700 mb-0">
            {cl.changesSummaryLegendNewTitle}
          </Typography>
          <Typography variant="body2" className="text-gray">
            {cl.changesSummaryLegendNewDesc}
          </Typography>
        </div>
      </div>
      <div className="d-flex gap-2 mb-4 review-changes-summary-card__legend-row ">
        <HorizontalRuleIcon
          sx={{
            color: "var(--color-foreground-muted)",
            fontSize: 14,
            backgroundColor: "var(--color-primary-subtle)",
            borderRadius: "50%",
          }}
        />
        <div>
          <Typography variant="subtitle2" className="fweight-700 mb-0">
            {cl.changesSummaryLegendOldTitle}
          </Typography>
          <Typography variant="body2" className="text-gray">
            {cl.changesSummaryLegendOldDesc}
          </Typography>
        </div>
      </div>
      <div className="review-changes-summary-card__total">
        <Typography variant="body2" className="text-gray mb-1">
          {cl.totalChanges}
        </Typography>
        <Typography variant="h5" className="fweight-700">
          {cl.totalChangesFields.replace("{count}", String(changeCount))}
        </Typography>
      </div>
  </Card>
);

ReviewChangesSummary.propTypes = {
  changeCount: PropTypes.number.isRequired,
  cl: PropTypes.object.isRequired,
};

export default ReviewChangesSummary;
